const MAX_PHONE_LENGTH = 15
const TOO_LONG_STATUS = 'TOO_LONG'
const DEFAULT_DDI = '+55'
const PAGE_SIZE = 10

const COUNTRY_NAMES = {
  AC: 'Ilha de Ascensão',
  AD: 'Andorra',
  AE: 'Emirados Árabes Unidos',
  AF: 'Afeganistão',
  AG: 'Antígua e Barbuda',
  AI: 'Anguila',
  AL: 'Albânia',
  AM: 'Armênia',
  AO: 'Angola',
  AR: 'Argentina',
  AS: 'Samoa Americana',
  AT: 'Áustria',
  AU: 'Austrália',
  AW: 'Aruba',
  AX: 'Ilhas Åland',
  AZ: 'Azerbaijão',
  BA: 'Bósnia e Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Bélgica',
  BF: 'Burkina Faso',
  BG: 'Bulgária',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'São Bartolomeu',
  BM: 'Bermudas',
  BN: 'Brunei',
  BO: 'Bolívia',
  BQ: 'Bonaire, Santo Eustáquio e Saba',
  BR: 'Brasil',
  BS: 'Bahamas',
  BT: 'Butão',
  BW: 'Botsuana',
  BY: 'Bielorrússia',
  BZ: 'Belize',
  CA: 'Canadá',
  CC: 'Ilhas Cocos (Keeling)',
  CD: 'Congo (República Democrática)',
  CF: 'República Centro-Africana',
  CG: 'Congo',
  CH: 'Suíça',
  CI: 'Costa do Marfim',
  CK: 'Ilhas Cook',
  CL: 'Chile',
  CM: 'Camarões',
  CN: 'China',
  CO: 'Colômbia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçao',
  CX: 'Ilha Christmas',
  CY: 'Chipre',
  CZ: 'República Tcheca',
  DE: 'Alemanha',
  DJ: 'Djibuti',
  DK: 'Dinamarca',
  DM: 'Dominica',
  DO: 'República Dominicana',
  DZ: 'Argélia',
  EC: 'Equador',
  EE: 'Estônia',
  EG: 'Egito',
  EH: 'Saara Ocidental',
  ER: 'Eritreia',
  ES: 'Espanha',
  ET: 'Etiópia',
  FI: 'Finlândia',
  FJ: 'Fiji',
  FK: 'Ilhas Malvinas',
  FM: 'Micronésia',
  FO: 'Ilhas Faroe',
  FR: 'França',
  GA: 'Gabão',
  GB: 'Reino Unido',
  GD: 'Granada',
  GE: 'Geórgia',
  GF: 'Guiana Francesa',
  GG: 'Guernsey',
  GH: 'Gana',
  GI: 'Gibraltar',
  GL: 'Groenlândia',
  GM: 'Gâmbia',
  GN: 'Guiné',
  GP: 'Guadalupe',
  GQ: 'Guiné Equatorial',
  GR: 'Grécia',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guiné-Bissau',
  GY: 'Guiana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croácia',
  HT: 'Haiti',
  HU: 'Hungria',
  ID: 'Indonésia',
  IE: 'Irlanda',
  IL: 'Israel',
  IM: 'Ilha de Man',
  IN: 'Índia',
  IO: 'Território Britânico do Oceano Índico',
  IQ: 'Iraque',
  IR: 'Irã',
  IS: 'Islândia',
  IT: 'Itália',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordânia',
  JP: 'Japão',
  KE: 'Quênia',
  KG: 'Quirguistão',
  KH: 'Camboja',
  KI: 'Quiribati',
  KM: 'Comores',
  KN: 'São Cristóvão e Nevis',
  KP: 'Coreia do Norte',
  KR: 'Coreia do Sul',
  KW: 'Kuwait',
  KY: 'Ilhas Cayman',
  KZ: 'Cazaquistão',
  LA: 'Laos',
  LB: 'Líbano',
  LC: 'Santa Lúcia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Libéria',
  LS: 'Lesoto',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  LV: 'Letônia',
  LY: 'Líbia',
  MA: 'Marrocos',
  MC: 'Mônaco',
  MD: 'Moldávia',
  ME: 'Montenegro',
  MF: 'São Martinho (França)',
  MG: 'Madagáscar',
  MH: 'Ilhas Marshall',
  MK: 'Macedônia do Norte',
  ML: 'Mali',
  MM: 'Mianmar',
  MN: 'Mongólia',
  MO: 'Macau',
  MP: 'Ilhas Marianas do Norte',
  MQ: 'Martinica',
  MR: 'Mauritânia',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Maurício',
  MV: 'Maldivas',
  MW: 'Malawi',
  MX: 'México',
  MY: 'Malásia',
  MZ: 'Moçambique',
  NA: 'Namíbia',
  NC: 'Nova Caledônia',
  NE: 'Níger',
  NF: 'Ilha Norfolk',
  NG: 'Nigéria',
  NI: 'Nicarágua',
  NL: 'Países Baixos',
  NO: 'Noruega',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'Nova Zelândia',
  OM: 'Omã',
  PA: 'Panamá',
  PE: 'Peru',
  PF: 'Polinésia Francesa',
  PG: 'Papua-Nova Guiné',
  PH: 'Filipinas',
  PK: 'Paquistão',
  PL: 'Polônia',
  PM: 'Saint Pierre e Miquelon',
  PR: 'Porto Rico',
  PS: 'Palestina',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguai',
  QA: 'Catar',
  RE: 'Reunião',
  RO: 'Romênia',
  RS: 'Sérvia',
  RU: 'Rússia',
  RW: 'Ruanda',
  SA: 'Arábia Saudita',
  SB: 'Ilhas Salomão',
  SC: 'Seicheles',
  SD: 'Sudão',
  SE: 'Suécia',
  SG: 'Singapura',
  SH: 'Santa Helena',
  SI: 'Eslovênia',
  SJ: 'Svalbard e Jan Mayen',
  SK: 'Eslováquia',
  SL: 'Serra Leoa',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somália',
  SR: 'Suriname',
  SS: 'Sudão do Sul',
  ST: 'São Tomé e Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten (Países Baixos)',
  SY: 'Síria',
  SZ: 'Essuatíni',
  TA: 'Tristão da Cunha',
  TC: 'Ilhas Turks e Caicos',
  TD: 'Chade',
  TG: 'Togo',
  TH: 'Tailândia',
  TJ: 'Tajiquistão',
  TK: 'Toquelau',
  TL: 'Timor-Leste',
  TM: 'Turcomenistão',
  TN: 'Tunísia',
  TO: 'Tonga',
  TR: 'Turquia',
  TT: 'Trinidad e Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzânia',
  UA: 'Ucrânia',
  UG: 'Uganda',
  US: 'Estados Unidos da América',
  UY: 'Uruguai',
  UZ: 'Uzbequistão',
  VA: 'Vaticano',
  VC: 'São Vicente e Granadinas',
  VE: 'Venezuela',
  VG: 'Ilhas Virgens Britânicas',
  VI: 'Ilhas Virgens Americanas',
  VN: 'Vietnã',
  VU: 'Vanuatu',
  WF: 'Wallis e Futuna',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Iêmen',
  YT: 'Mayotte',
  ZA: 'África do Sul',
  ZM: 'Zâmbia',
  ZW: 'Zimbábue',
}

const countries = {
  COUNTRY_NAMES,
  DEFAULT_DDI,
  MAX_PHONE_LENGTH,
  PAGE_SIZE,
  TOO_LONG_STATUS,
}

export default countries
